import React from "react";
import PropTypes from "prop-types";
import { Card, Button, Tooltip } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";

const PendingReportsCard = ({ pendingCount, onShowModal }) => (
  <Card title="Pending Progress Reports" style={{ marginBottom: 20 }}>
    <p>You have {pendingCount} pending progress report(s).</p>
    {pendingCount === 0 ? (
      <Tooltip title="No pending reports available to submit" placement="top">
        <span>
          <Button type="primary" disabled icon={<InfoCircleOutlined />}>
            Submit Report
          </Button>
        </span>
      </Tooltip>
    ) : (
      <Button type="primary" onClick={onShowModal}>
        Submit Report
      </Button>
    )}
  </Card>
);

PendingReportsCard.propTypes = {
  pendingCount: PropTypes.number.isRequired,
  onShowModal: PropTypes.func.isRequired,
};

export default PendingReportsCard;
